import { BffFacility, FacilityFieldsFragment } from '@aspendental/shared-components-web/lib/graphql/__generated/sdk';

export const getPhoneNumber = (facility: BffFacility | FacilityFieldsFragment | null) => {
	if (!facility) return '';
	if ('phoneNumber' in facility) {
		return facility.phoneNumber;
	}
	if ('technicalInfrastructure' in facility) {
		return facility.technicalInfrastructure?.phoneNumber;
	}
};
